<!-- 
Hodnoty statusu su nastavene podla ciselnika cis_crm_obch_pripady_stavy where flagy = 0
-->

<template>
  <v-dialog
    v-model="dialog.value"
    overlay-color="#000"
    overlay-opacity="0.66"
    :persistent="dialog.persistent"
    :max-width="dialog.width"
  >
    <v-card class="dialog-card">
      <v-card-title class="d-flex justify-space-between" :class="dialog.closeIcon.value ? 'dialog-title-close': null">
        <span v-html="dialog.header"></span>
        <template v-if="dialog.closeIcon.value">
          <template v-if="dialog.closeIcon.func == null">
            <v-btn icon @click="close()">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
          <template v-else>
            <v-btn icon @click="dialog.closeIcon.func">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </template>
        </template>
      </v-card-title>
      <v-card-text :class="dialog.textClass">
        <span v-html="dialog.text"></span>
      </v-card-text>
      <v-card-actions v-if="isAction">
        <v-spacer v-if="!isMobile"></v-spacer>
        <v-btn
          v-if="dialog.closeBtn.value"
          :class="[dialog.closeBtn.primaryStyle ? 'btn-primary' : 'btn-secondary']"
          density="default"
          variant="elevated"
          :disabled="dialog.closeBtn.disabled"
          @click="close()"
        >
          {{ dialog.closeBtn.text }}
        </v-btn>
        <v-btn
          v-if="dialog.secondaryBtn.text"
          class="btn-secondary"
          density="default"
          variant="elevated"
          :disabled="dialog.secondaryBtn.disabled"
          :loading="dialog.secondaryBtn.loading"
          @click="dialog.secondaryBtn.func"
        >
          {{ dialog.secondaryBtn.text }}
        </v-btn>
        <v-btn
          v-if="dialog.primaryBtn.text"
          class="btn-primary"
          variant="elevated"
          density="default"
          @click="dialog.primaryBtn.func"
          :disabled="dialog.primaryBtn.disabled"
          :loading="dialog.primaryBtn.loading"
        >
          {{ dialog.primaryBtn.text }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapMutations, mapState, mapGetters } from 'vuex';
export default {
  computed: {
    ...mapGetters(['dialog','isMobile']),
    isAction() {
      return (
        this.dialog.closeBtn.value ||
        this.dialog.primaryBtn.text != null ||
        this.dialog.secondaryBtn.text != null
      );
    },
  },
  watch:{
    'dialog.value'(val){
      if(val == true && this.dialog.timer != null){
        setTimeout(()=>{
          this.closeDialog();
        },this.dialog.timer);
      }
    }
  },
  data() {
    return {
      timer: null
    };
  },
  methods: {
    ...mapMutations(['closeDialog']),
    close() {
      this.closeDialog();
    },
  },
};
</script>
